import React from "react";
import { useTranslation } from "react-i18next";

const TronHashInput = ({
  value,
  onChange,
  placeholder = "ENTER_HASH",
  showAllert,
}) => {
  const { t } = useTranslation("exchange");
  const BANK_WALLET_URL = "TGpHcrZtuKvdWpY7ANWz9ZQbJbXdLHMYDJ";

  const handleCopy = () => {
    const msg = `${t("WALLET_COPIED")} : ${BANK_WALLET_URL}`;
    console.log(msg);
    navigator.clipboard.writeText(BANK_WALLET_URL).then(() => {
      if (window.Telegram?.WebApp) {
        window.Telegram.WebApp.showAlert(msg);
      } else {
        alert(msg);
      }
    });
  };

  return (
    <div className="w-full mt-4">
      <button
        type="button"
        onClick={handleCopy}
        className="
          w-full px-4 py-2 rounded-xl
          bg-blue-500 text-white text-sm font-medium
          hover:bg-blue-600
          active:bg-blue-700 active:scale-95
          focus:outline-none
          transition-all duration-150
        "
      >
        {t("COPY_WALLET")}
      </button>

      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t(placeholder)}
        className="
          w-full mt-3 rounded-xl px-4 py-3
          border-2 border-transparent
          bg-gray-100
          text-gray-800 text-sm
          focus:outline-none
          focus:border-blue-500
          focus:bg-gray-50
          transition-all duration-300
          placeholder-gray-400
        "
      />
      <p className="text-xs text-gray-500 mt-1">{t("HASH_SHOULD_CONTAIN")}</p>
    </div>
  );
};

export default TronHashInput;
